import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
  Input,
  FormGroup,
  Form,
  Label,
} from "reactstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";

import { useDispatch } from "react-redux";
import { addApiUsers, updateApiUsers } from "../../../store/apiusers/actions";
import RadialChart1 from "../../Dashboard/userpanelChart1";

const schema = yup.object().shape({
  owner: yup.string().max(100).required(),

  accounts: yup.number().required(),
});

export default function AddNew({
  modal_center,
  tog_center,
  setmodal_center,
  data,
}) {
  const dispatch = useDispatch();

  const [files, setFiles] = useState(null);
  const [base64Image, setBase64Image] = useState("");

  const date = new Date(data.birthday);

  const formattedDate = `${date.getFullYear()}-${String(
    date.getMonth() + 1
  ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      owner: data.owner,
      accounts: data.accounts,
      state: data.is_active ? true : false,
    },
  });

  const onSubmit = (formData) => {
    if (Object.keys(data).length !== 0) {
      // let data = data.append("image", files);
      dispatch(updateApiUsers({ ...formData, id: data.id }));
    } else {
      // let data = data.append("image", files);
      dispatch(addApiUsers({ ...formData }));
    }
    if (!Object.keys(errors).length) {
      //   reset();
      setmodal_center(false);
    }
  };

  return (
    <Modal
      isOpen={modal_center}
      toggle={() => {
        tog_center();
      }}
      centered
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
          style={{ display: "flex", alignItems: "center" }}
        >
          <i class="ri-apple-fill" style={{ paddingRight: 5 }}></i>{" "}
          {Object.keys(data).length !== 0 ? "Update" : "Add"} Api User
        </h5>
        <button
          type="button"
          onClick={() => {
            setmodal_center(false);
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        {Object.keys(data).length !== 0 ? (
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <div id="radialchart-1" className="apex-charts" dir="ltr">
                    <RadialChart1 pres={Math.floor(data.sold_percentage)} />
                  </div>
                </div>

                <div className="flex-grow-1 overflow-hidden  align-self-center">
                  <p className="mb-1">Apple IDs</p>
                  <h5 className="mb-3">
                    Accounts Number: {data.total_products} /{" "}
                    {data.sold_products}
                  </h5>
                  <p className="text-truncate mb-0"></p>
                </div>
              </div>
            </CardBody>
          </Card>
        ) : null}
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-2">
            {Object.keys(data).length === 0 ? (
              <Col md="12">
                <div className="field">
                  <input
                    {...register("owner")}
                    className={`form-control ${
                      errors.owner ? "is-invalid" : null
                    }`}
                    placeholder=""
                    type="text"
                  />
                  <span class="label">Enter Name</span>
                </div>
              </Col>
            ) : null}
            <Col md="12">
              <div className="field">
                <input
                  {...register("accounts")}
                  className={`form-control ${
                    errors.accounts ? "is-invalid" : null
                  }`}
                  placeholder=""
                  type="number"
                />
                <span class="label">Max Account</span>
              </div>
            </Col>
          </Row>

          <hr />

          {Object.keys(data).length === 0 ? (
            <Row className="mb-3">
              <Col md="6">
                <div className="form-check form-switch form-switch-lg mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="customSwitchsizelg"
                    {...register("state")}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="customSwitchsizelg"
                  >
                    State
                  </label>
                </div>
              </Col>
            </Row>
          ) : null}

          <div className="d-flex flex-wrap gap-2 justify-content-center">
            <button
              type="button"
              className="btn btn-lg btn-secondary"
              onClick={() => {
                setmodal_center(false);
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              //   onClick={() => {
              //     setmodal_center(false);
              //   }}
              className="btn btn-lg btn-primary"
            >
              {Object.keys(data).length !== 0 ? "Update" : "Add New"}
            </button>
          </div>
        </Form>
      </div>
    </Modal>
  );
}
